(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/pix-mix/components/pix-mix-item/assets/javascripts/pix-mix-item.js') >= 0) return;  svs.modules.push('/modules/pix-mix/components/pix-mix-item/assets/javascripts/pix-mix-item.js');
"use strict";


const {
  cdn
} = svs.core.config.data.svsconfig;
const {
  clx
} = svs.components.lbUtils;
const {
  AnimateNumber
} = svs.pix_mix.components.common;
const logger = new svs.core.log.Logger('svs.pix_mix.Pixmixen');
const PixMixItem = _ref => {
  let {
    delay,
    disabled,
    product,
    onClick
  } = _ref;
  const {
    branding,
    systemCost
  } = product;
  const brand = (branding === null || branding === void 0 ? void 0 : branding.brand[0]) || 'default';
  if (!product.drawNumber) {
    logger.info("drawNumber is not set productId:".concat(product.id));
  }
  return React.createElement("div", {
    className: clx("pix-mix-item pix-mix-item-".concat(brand), 'pix-mix-item-enter', {
      'pix-mix-item-disabled': !product.drawNumber || disabled
    }),
    "data-testid": "qa-pix-mix-item",
    onClick: e => !disabled && onClick(e),
    style: {
      '--delay': "".concat(delay, "ms")
    }
  }, React.createElement("div", {
    className: "pix-mix-item-content"
  }, React.createElement("div", {
    className: "pix-mix-product-logo"
  }, React.createElement("img", {
    alt: "".concat(branding.displayName, " logotyp"),
    src: "".concat(cdn, "/images/pix-mix/").concat(brand, ".png")
  })), React.createElement("p", {
    className: "f-center f-550"
  }, branding.displayName)), React.createElement("div", {
    className: "pix-mix-item-rows"
  }, React.createElement(AnimateNumber, {
    className: "pix-mix-item-system-size",
    value: systemCost
  }, React.createElement("span", null, "rader"))));
};
PixMixItem.defaultProps = {
  delay: 0
};
setGlobal('svs.pix_mix.components.PixMixItem', PixMixItem);

 })(window);